var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"all-center b-w"},[_c('b-col',{attrs:{"cols":"12","md":"6","lg":"5","xl":"3"}},[_c('div',{staticClass:"b-w"},[_c('login-form')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }